import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: string;
  Date: Date;
  Json: { [key: string]: string | number | boolean | null };
  NullableBigInt: string | null;
  NullableBoolean: boolean | null;
  NullableDate: Date | null;
  NullableFloat: number | null;
  NullableInt: number | null;
  NullableJson: { [key: string]: string | number | boolean | null } | null;
  NullableString: string | null;
  UnknownTypeStringified: string | null;
};

export type AddSubmissionAssociatedFields = {
  submissionItemFields?: InputMaybe<Array<AddSubmissionWithSubmissionItemFieldsInput>>;
};

export type AddSubmissionInput = {
  associatedFields?: InputMaybe<AddSubmissionAssociatedFields>;
  primaryFields: AddSubmissionPrimaryFields;
};

export type AddSubmissionPrimaryFields = {
  formId: Scalars['Int'];
};

export type AddSubmissionWithSubmissionItemFieldsInput = {
  primaryFields: AddSubmissionWithSubmissionItemFieldsPrimaryFields;
};

export type AddSubmissionWithSubmissionItemFieldsPrimaryFields = {
  itemFieldId: Scalars['Int'];
  value?: InputMaybe<Scalars['NullableString']>;
};

export type AddSubmissionsInput = {
  inputs: Array<AddSubmissionInput>;
};

export type AddSubmissionsOutput = {
  __typename?: 'AddSubmissionsOutput';
  rows: Array<AddedSubmission>;
};

export type AddedSubmission = {
  __typename?: 'AddedSubmission';
  id: Scalars['Int'];
};

export type BigIntFilter = {
  op: FilterOperators;
  val: Scalars['BigInt'];
};

export type BooleanFilter = {
  op: FilterOperators;
  val: Scalars['Boolean'];
};

export type DateFilter = {
  op: FilterOperators;
  val: Scalars['Date'];
};

export enum FilterOperators {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  ILike = 'I_LIKE',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  Like = 'LIKE',
  NotEqual = 'NOT_EQUAL'
}

export type FloatFilter = {
  op: FilterOperators;
  val: Scalars['Float'];
};

export type Form = {
  __typename?: 'Form';
  code: Scalars['String'];
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  logoUrl?: Maybe<Scalars['NullableString']>;
  name: Scalars['String'];
  sections: Array<Section>;
  updatedAt: Scalars['Date'];
};

export type FormBuilderForm = {
  __typename?: 'FormBuilderForm';
  closingMessage?: Maybe<Scalars['NullableString']>;
  code: Scalars['String'];
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  logoUrl?: Maybe<Scalars['NullableString']>;
  name: Scalars['String'];
  sections: Array<FormBuilderSection>;
  submissionCount: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type FormBuilderFormFieldsInput = {
  closingMessage?: InputMaybe<Scalars['NullableString']>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['NullableString']>;
  logoUrl?: InputMaybe<Scalars['NullableString']>;
  name: Scalars['String'];
};

export type FormBuilderFormInput = {
  form: FormBuilderFormFieldsInput;
  sections: Array<FormBuilderSectionInput>;
};

export type FormBuilderFormListOutput = {
  __typename?: 'FormBuilderFormListOutput';
  count: Scalars['Int'];
  rows: Array<FormBuilderForm>;
};

export type FormBuilderItem = {
  __typename?: 'FormBuilderItem';
  code?: Maybe<Scalars['NullableString']>;
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  itemFields: Array<FormBuilderItemField>;
  name: Scalars['String'];
  relatedFormCode?: Maybe<Scalars['NullableString']>;
  relatedItemCode?: Maybe<Scalars['NullableString']>;
  relatedItemFieldCode?: Maybe<Scalars['NullableString']>;
  relatedSectionCode?: Maybe<Scalars['NullableString']>;
  sortOrder: Scalars['Int'];
};

export type FormBuilderItemField = {
  __typename?: 'FormBuilderItemField';
  code?: Maybe<Scalars['NullableString']>;
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  isRequired: Scalars['Int'];
  name?: Maybe<Scalars['NullableString']>;
  placeholder?: Maybe<Scalars['NullableString']>;
  selectId?: Maybe<Scalars['NullableInt']>;
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['NullableString']>;
  typeCode: Scalars['String'];
};

export type FormBuilderItemFieldInput = {
  code?: InputMaybe<Scalars['NullableString']>;
  description?: InputMaybe<Scalars['NullableString']>;
  isRequired: Scalars['Int'];
  name?: InputMaybe<Scalars['NullableString']>;
  placeholder?: InputMaybe<Scalars['NullableString']>;
  selectId?: InputMaybe<Scalars['NullableInt']>;
  sortOrder: Scalars['Int'];
  subtitle?: InputMaybe<Scalars['NullableString']>;
  typeCode: Scalars['String'];
};

export type FormBuilderItemFieldType = {
  __typename?: 'FormBuilderItemFieldType';
  code: Scalars['String'];
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type FormBuilderItemInput = {
  code?: InputMaybe<Scalars['NullableString']>;
  description?: InputMaybe<Scalars['NullableString']>;
  itemFields: Array<FormBuilderItemFieldInput>;
  name: Scalars['String'];
  relatedFormCode?: InputMaybe<Scalars['NullableString']>;
  relatedItemCode?: InputMaybe<Scalars['NullableString']>;
  relatedItemFieldCode?: InputMaybe<Scalars['NullableString']>;
  relatedSectionCode?: InputMaybe<Scalars['NullableString']>;
  sortOrder: Scalars['Int'];
};

export type FormBuilderListInput = {
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['NullableString']>;
};

export type FormBuilderMutationResult = {
  __typename?: 'FormBuilderMutationResult';
  id: Scalars['Int'];
};

export type FormBuilderSection = {
  __typename?: 'FormBuilderSection';
  code?: Maybe<Scalars['NullableString']>;
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  items: Array<FormBuilderItem>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type FormBuilderSectionInput = {
  code?: InputMaybe<Scalars['NullableString']>;
  description?: InputMaybe<Scalars['NullableString']>;
  items: Array<FormBuilderItemInput>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type FormBuilderSelect = {
  __typename?: 'FormBuilderSelect';
  id: Scalars['Int'];
  name: Scalars['String'];
  options: Array<FormBuilderSelectOption>;
  updatedAt: Scalars['Date'];
};

export type FormBuilderSelectInput = {
  name: Scalars['String'];
  options: Array<FormBuilderSelectOptionInput>;
};

export type FormBuilderSelectListOutput = {
  __typename?: 'FormBuilderSelectListOutput';
  count: Scalars['Int'];
  rows: Array<FormBuilderSelect>;
};

export type FormBuilderSelectOption = {
  __typename?: 'FormBuilderSelectOption';
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type FormBuilderSelectOptionInput = {
  description?: InputMaybe<Scalars['NullableString']>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type GetFormsFilter = {
  and?: InputMaybe<Array<GetFormsFilter>>;
  fields?: InputMaybe<GetFormsFilterFields>;
  or?: InputMaybe<Array<GetFormsFilter>>;
};

export type GetFormsFilterFields = {
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
};

export type GetFormsInput = {
  filter?: InputMaybe<GetFormsFilter>;
  pagination?: InputMaybe<Pagination>;
  sortBys?: InputMaybe<Array<GetFormsSortBy>>;
};

export type GetFormsOutput = {
  __typename?: 'GetFormsOutput';
  count: Scalars['Int'];
  rows: Array<Form>;
};

export type GetFormsSortBy = {
  isDesc?: InputMaybe<Scalars['Boolean']>;
  name: GetFormsSortByNames;
};

export enum GetFormsSortByNames {
  CreatedAt = 'createdAt'
}

export type GetItemFieldTypesOutput = {
  __typename?: 'GetItemFieldTypesOutput';
  count: Scalars['Int'];
  rows: Array<ItemFieldType>;
};

export type GetItemFieldsOutput = {
  __typename?: 'GetItemFieldsOutput';
  count: Scalars['Int'];
  rows: Array<ItemField>;
};

export type GetItemsOutput = {
  __typename?: 'GetItemsOutput';
  count: Scalars['Int'];
  rows: Array<Item>;
};

export type GetSectionsOutput = {
  __typename?: 'GetSectionsOutput';
  count: Scalars['Int'];
  rows: Array<Section>;
};

export type GetSelectOptionsFilter = {
  and?: InputMaybe<Array<GetSelectOptionsFilter>>;
  fields?: InputMaybe<GetSelectOptionsFilterFields>;
  or?: InputMaybe<Array<GetSelectOptionsFilter>>;
};

export type GetSelectOptionsFilterFields = {
  name?: InputMaybe<StringFilter>;
  selectId?: InputMaybe<IntFilter>;
};

export type GetSelectOptionsInput = {
  filter?: InputMaybe<GetSelectOptionsFilter>;
  pagination?: InputMaybe<Pagination>;
  sortBys?: InputMaybe<Array<GetSelectOptionsSortBy>>;
};

export type GetSelectOptionsOutput = {
  __typename?: 'GetSelectOptionsOutput';
  count: Scalars['Int'];
  rows: Array<SelectOption>;
};

export type GetSelectOptionsSortBy = {
  isDesc?: InputMaybe<Scalars['Boolean']>;
  name: GetSelectOptionsSortByNames;
};

export enum GetSelectOptionsSortByNames {
  Name = 'name',
  SortOrder = 'sortOrder'
}

export type GetSubmissionItemFieldsOutput = {
  __typename?: 'GetSubmissionItemFieldsOutput';
  count: Scalars['Int'];
  rows: Array<SubmissionItemField>;
};

export type GetSubmissionsFilter = {
  and?: InputMaybe<Array<GetSubmissionsFilter>>;
  fields?: InputMaybe<GetSubmissionsFilterFields>;
  or?: InputMaybe<Array<GetSubmissionsFilter>>;
};

export type GetSubmissionsFilterFields = {
  formId?: InputMaybe<IntFilter>;
};

export type GetSubmissionsInput = {
  filter?: InputMaybe<GetSubmissionsFilter>;
  pagination?: InputMaybe<Pagination>;
  sortBys?: InputMaybe<Array<GetSubmissionsSortBy>>;
};

export type GetSubmissionsOutput = {
  __typename?: 'GetSubmissionsOutput';
  count: Scalars['Int'];
  rows: Array<Submission>;
};

export type GetSubmissionsSortBy = {
  isDesc?: InputMaybe<Scalars['Boolean']>;
  name: GetSubmissionsSortByNames;
};

export enum GetSubmissionsSortByNames {
  CreatedAt = 'createdAt'
}

export type IntFilter = {
  op: FilterOperators;
  val: Scalars['Int'];
};

export type Item = {
  __typename?: 'Item';
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  itemFields: Array<ItemField>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type ItemField = {
  __typename?: 'ItemField';
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  isRequired: Scalars['Int'];
  name?: Maybe<Scalars['NullableString']>;
  placeholder?: Maybe<Scalars['NullableString']>;
  selectId?: Maybe<Scalars['NullableInt']>;
  sortOrder: Scalars['Int'];
  subtitle?: Maybe<Scalars['NullableString']>;
  type: ItemFieldType;
};

export type ItemFieldType = {
  __typename?: 'ItemFieldType';
  code: Scalars['String'];
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum ItemFieldTypeCodes {
  Date = 'date',
  FloatInput = 'float_input',
  IntInput = 'int_input',
  Multiselect = 'multiselect',
  Radio = 'radio',
  Select = 'select',
  TextArea = 'text_area',
  TextInput = 'text_input'
}

export type JsonFieldSortBy = {
  index: Scalars['Int'];
  isDesc?: InputMaybe<Scalars['Boolean']>;
  jsonFieldName: Scalars['String'];
  sortByName: Scalars['String'];
};

export type JsonFilter = {
  name: Scalars['String'];
  op: FilterOperators;
  val: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addSubmissions: AddSubmissionsOutput;
  createFormBuilderForm: FormBuilderMutationResult;
  createFormBuilderSelect: FormBuilderMutationResult;
  deleteFormBuilderForm: Scalars['Boolean'];
  deleteFormBuilderSelect: Scalars['Boolean'];
  updateFormBuilderForm: FormBuilderMutationResult;
  updateFormBuilderSelect: FormBuilderMutationResult;
};


export type MutationAddSubmissionsArgs = {
  input: AddSubmissionsInput;
};


export type MutationCreateFormBuilderFormArgs = {
  input: FormBuilderFormInput;
};


export type MutationCreateFormBuilderSelectArgs = {
  input: FormBuilderSelectInput;
};


export type MutationDeleteFormBuilderFormArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFormBuilderSelectArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateFormBuilderFormArgs = {
  id: Scalars['Int'];
  input: FormBuilderFormInput;
};


export type MutationUpdateFormBuilderSelectArgs = {
  id: Scalars['Int'];
  input: FormBuilderSelectInput;
};

export type NullableBigIntFilter = {
  op: FilterOperators;
  val?: InputMaybe<Scalars['NullableBigInt']>;
};

export type NullableBooleanFilter = {
  op: FilterOperators;
  val?: InputMaybe<Scalars['NullableBoolean']>;
};

export type NullableDateFilter = {
  op: FilterOperators;
  val?: InputMaybe<Scalars['NullableDate']>;
};

export type NullableFloatFilter = {
  op: FilterOperators;
  val?: InputMaybe<Scalars['NullableFloat']>;
};

export type NullableIntFilter = {
  op: FilterOperators;
  val?: InputMaybe<Scalars['NullableInt']>;
};

export type NullableStringFilter = {
  op: FilterOperators;
  val?: InputMaybe<Scalars['NullableString']>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  getFormBuilderForm?: Maybe<FormBuilderForm>;
  getFormBuilderSelect?: Maybe<FormBuilderSelect>;
  getForms: GetFormsOutput;
  getSelectOptions: GetSelectOptionsOutput;
  getSubmissions: GetSubmissionsOutput;
  listFormBuilderForms: FormBuilderFormListOutput;
  listFormBuilderItemFieldTypes: Array<FormBuilderItemFieldType>;
  listFormBuilderSelects: FormBuilderSelectListOutput;
};


export type QueryGetFormBuilderFormArgs = {
  id: Scalars['Int'];
};


export type QueryGetFormBuilderSelectArgs = {
  id: Scalars['Int'];
};


export type QueryGetFormsArgs = {
  input?: InputMaybe<GetFormsInput>;
};


export type QueryGetSelectOptionsArgs = {
  input?: InputMaybe<GetSelectOptionsInput>;
};


export type QueryGetSubmissionsArgs = {
  input?: InputMaybe<GetSubmissionsInput>;
};


export type QueryListFormBuilderFormsArgs = {
  input?: InputMaybe<FormBuilderListInput>;
};


export type QueryListFormBuilderSelectsArgs = {
  input?: InputMaybe<FormBuilderListInput>;
};

export type Section = {
  __typename?: 'Section';
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  items: Array<Item>;
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type SelectOption = {
  __typename?: 'SelectOption';
  description?: Maybe<Scalars['NullableString']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
};

export type StringFilter = {
  op: FilterOperators;
  val: Scalars['String'];
};

export type Submission = {
  __typename?: 'Submission';
  id: Scalars['Int'];
  submissionItemFields: Array<SubmissionItemField>;
};

export type SubmissionItemField = {
  __typename?: 'SubmissionItemField';
  id: Scalars['Int'];
  itemFieldId: Scalars['Int'];
  value?: Maybe<Scalars['NullableString']>;
};

export type FormFragment = { __typename?: 'Form', id: number, name: string, description?: string | null | null, logoUrl?: string | null | null, code: string, updatedAt: Date, sections: Array<{ __typename?: 'Section', id: number, name: string, description?: string | null | null, sortOrder: number, items: Array<{ __typename?: 'Item', id: number, name: string, description?: string | null | null, sortOrder: number, itemFields: Array<{ __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, type: { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null } }> }> }> };

export type FormListItemFragment = { __typename?: 'Form', code: string, id: number, name: string };

export type SectionFragment = { __typename?: 'Section', id: number, name: string, description?: string | null | null, sortOrder: number, items: Array<{ __typename?: 'Item', id: number, name: string, description?: string | null | null, sortOrder: number, itemFields: Array<{ __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, type: { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null } }> }> };

export type SectionListItemFragment = { __typename?: 'Section', id: number, name: string, description?: string | null | null, sortOrder: number };

export type ItemFragment = { __typename?: 'Item', id: number, name: string, description?: string | null | null, sortOrder: number, itemFields: Array<{ __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, type: { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null } }> };

export type ItemListItemFragment = { __typename?: 'Item', id: number, name: string, description?: string | null | null, sortOrder: number };

export type ItemFieldFragment = { __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, type: { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null } };

export type ItemFieldListItemFragment = { __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null };

export type TypeFragment = { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null };

export type SelectOptionFragment = { __typename?: 'SelectOption', id: number, name: string, description?: string | null | null, sortOrder: number };

export type AddSubmissionsMutationVariables = Exact<{
  input: AddSubmissionsInput;
}>;


export type AddSubmissionsMutation = { __typename?: 'Mutation', addSubmissions: { __typename?: 'AddSubmissionsOutput', rows: Array<{ __typename?: 'AddedSubmission', id: number }> } };

export type CreateFormBuilderFormMutationVariables = Exact<{
  input: FormBuilderFormInput;
}>;


export type CreateFormBuilderFormMutation = { __typename?: 'Mutation', createFormBuilderForm: { __typename?: 'FormBuilderMutationResult', id: number } };

export type UpdateFormBuilderFormMutationVariables = Exact<{
  id: Scalars['Int'];
  input: FormBuilderFormInput;
}>;


export type UpdateFormBuilderFormMutation = { __typename?: 'Mutation', updateFormBuilderForm: { __typename?: 'FormBuilderMutationResult', id: number } };

export type DeleteFormBuilderFormMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteFormBuilderFormMutation = { __typename?: 'Mutation', deleteFormBuilderForm: boolean };

export type CreateFormBuilderSelectMutationVariables = Exact<{
  input: FormBuilderSelectInput;
}>;


export type CreateFormBuilderSelectMutation = { __typename?: 'Mutation', createFormBuilderSelect: { __typename?: 'FormBuilderMutationResult', id: number } };

export type UpdateFormBuilderSelectMutationVariables = Exact<{
  id: Scalars['Int'];
  input: FormBuilderSelectInput;
}>;


export type UpdateFormBuilderSelectMutation = { __typename?: 'Mutation', updateFormBuilderSelect: { __typename?: 'FormBuilderMutationResult', id: number } };

export type DeleteFormBuilderSelectMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteFormBuilderSelectMutation = { __typename?: 'Mutation', deleteFormBuilderSelect: boolean };

export type GetFormsQueryVariables = Exact<{
  input?: InputMaybe<GetFormsInput>;
}>;


export type GetFormsQuery = { __typename?: 'Query', getForms: { __typename?: 'GetFormsOutput', count: number, rows: Array<{ __typename?: 'Form', code: string, id: number, name: string }> } };

export type GetFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetFormQuery = { __typename?: 'Query', getForms: { __typename?: 'GetFormsOutput', rows: Array<{ __typename?: 'Form', id: number, name: string, description?: string | null | null, logoUrl?: string | null | null, code: string, updatedAt: Date, sections: Array<{ __typename?: 'Section', id: number, name: string, description?: string | null | null, sortOrder: number, items: Array<{ __typename?: 'Item', id: number, name: string, description?: string | null | null, sortOrder: number, itemFields: Array<{ __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, type: { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null } }> }> }> }> } };

export type GetFormByFilterQueryVariables = Exact<{
  input?: InputMaybe<GetFormsInput>;
}>;


export type GetFormByFilterQuery = { __typename?: 'Query', getForms: { __typename?: 'GetFormsOutput', rows: Array<{ __typename?: 'Form', id: number, name: string, description?: string | null | null, logoUrl?: string | null | null, code: string, updatedAt: Date, sections: Array<{ __typename?: 'Section', id: number, name: string, description?: string | null | null, sortOrder: number, items: Array<{ __typename?: 'Item', id: number, name: string, description?: string | null | null, sortOrder: number, itemFields: Array<{ __typename?: 'ItemField', id: number, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, type: { __typename?: 'ItemFieldType', id: number, code: string, name: string, description?: string | null | null } }> }> }> }> } };

export type GetSelectOptionsQueryVariables = Exact<{
  input?: InputMaybe<GetSelectOptionsInput>;
}>;


export type GetSelectOptionsQuery = { __typename?: 'Query', getSelectOptions: { __typename?: 'GetSelectOptionsOutput', count: number, rows: Array<{ __typename?: 'SelectOption', id: number, name: string, description?: string | null | null, sortOrder: number }> } };

export type ListFormBuilderFormsQueryVariables = Exact<{
  input?: InputMaybe<FormBuilderListInput>;
}>;


export type ListFormBuilderFormsQuery = { __typename?: 'Query', listFormBuilderForms: { __typename?: 'FormBuilderFormListOutput', count: number, rows: Array<{ __typename?: 'FormBuilderForm', id: number, code: string, name: string, updatedAt: Date, submissionCount: number }> } };

export type GetFormBuilderFormQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetFormBuilderFormQuery = { __typename?: 'Query', getFormBuilderForm?: { __typename?: 'FormBuilderForm', id: number, code: string, name: string, description?: string | null | null, closingMessage?: string | null | null, logoUrl?: string | null | null, updatedAt: Date, submissionCount: number, sections: Array<{ __typename?: 'FormBuilderSection', id: number, code?: string | null | null, name: string, description?: string | null | null, sortOrder: number, items: Array<{ __typename?: 'FormBuilderItem', id: number, code?: string | null | null, name: string, description?: string | null | null, sortOrder: number, relatedFormCode?: string | null | null, relatedSectionCode?: string | null | null, relatedItemCode?: string | null | null, relatedItemFieldCode?: string | null | null, itemFields: Array<{ __typename?: 'FormBuilderItemField', id: number, code?: string | null | null, name?: string | null | null, description?: string | null | null, sortOrder: number, selectId?: number | null | null, placeholder?: string | null | null, subtitle?: string | null | null, isRequired: number, typeCode: string }> }> }> } | null };

export type ListFormBuilderSelectsQueryVariables = Exact<{
  input?: InputMaybe<FormBuilderListInput>;
}>;


export type ListFormBuilderSelectsQuery = { __typename?: 'Query', listFormBuilderSelects: { __typename?: 'FormBuilderSelectListOutput', count: number, rows: Array<{ __typename?: 'FormBuilderSelect', id: number, name: string, updatedAt: Date }> } };

export type GetFormBuilderSelectQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetFormBuilderSelectQuery = { __typename?: 'Query', getFormBuilderSelect?: { __typename?: 'FormBuilderSelect', id: number, name: string, updatedAt: Date, options: Array<{ __typename?: 'FormBuilderSelectOption', id: number, name: string, description?: string | null | null, sortOrder: number }> } | null };

export type ListFormBuilderItemFieldTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListFormBuilderItemFieldTypesQuery = { __typename?: 'Query', listFormBuilderItemFieldTypes: Array<{ __typename?: 'FormBuilderItemFieldType', id: number, code: string, name: string, description?: string | null | null }> };

export type GetSubmissionsQueryVariables = Exact<{
  input?: InputMaybe<GetSubmissionsInput>;
}>;


export type GetSubmissionsQuery = { __typename?: 'Query', getSubmissions: { __typename?: 'GetSubmissionsOutput', count: number, rows: Array<{ __typename?: 'Submission', id: number, submissionItemFields: Array<{ __typename?: 'SubmissionItemField', itemFieldId: number, value?: string | null | null }> }> } };

export const TypeFragmentDoc = gql`
    fragment Type on ItemFieldType {
  id
  code
  name
  description
}
    `;
export const ItemFieldFragmentDoc = gql`
    fragment ItemField on ItemField {
  id
  name
  description
  sortOrder
  selectId
  placeholder
  subtitle
  isRequired
  type {
    ...Type
  }
}
    ${TypeFragmentDoc}`;
export const ItemFragmentDoc = gql`
    fragment Item on Item {
  id
  name
  description
  sortOrder
  itemFields {
    ...ItemField
  }
}
    ${ItemFieldFragmentDoc}`;
export const SectionFragmentDoc = gql`
    fragment Section on Section {
  id
  name
  description
  sortOrder
  items {
    ...Item
  }
}
    ${ItemFragmentDoc}`;
export const FormFragmentDoc = gql`
    fragment Form on Form {
  id
  name
  description
  logoUrl
  code
  updatedAt
  sections {
    ...Section
  }
}
    ${SectionFragmentDoc}`;
export const FormListItemFragmentDoc = gql`
    fragment FormListItem on Form {
  code
  id
  name
}
    `;
export const SectionListItemFragmentDoc = gql`
    fragment SectionListItem on Section {
  id
  name
  description
  sortOrder
}
    `;
export const ItemListItemFragmentDoc = gql`
    fragment ItemListItem on Item {
  id
  name
  description
  sortOrder
}
    `;
export const ItemFieldListItemFragmentDoc = gql`
    fragment ItemFieldListItem on ItemField {
  id
  name
  description
  sortOrder
  selectId
  placeholder
  subtitle
}
    `;
export const SelectOptionFragmentDoc = gql`
    fragment SelectOption on SelectOption {
  id
  name
  description
  sortOrder
}
    `;
export const AddSubmissionsDocument = gql`
    mutation AddSubmissions($input: AddSubmissionsInput!) {
  addSubmissions(input: $input) {
    rows {
      id
    }
  }
}
    `;
export type AddSubmissionsMutationFn = Apollo.MutationFunction<AddSubmissionsMutation, AddSubmissionsMutationVariables>;

/**
 * __useAddSubmissionsMutation__
 *
 * To run a mutation, you first call `useAddSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubmissionsMutation, { data, loading, error }] = useAddSubmissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<AddSubmissionsMutation, AddSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubmissionsMutation, AddSubmissionsMutationVariables>(AddSubmissionsDocument, options);
      }
export type AddSubmissionsMutationHookResult = ReturnType<typeof useAddSubmissionsMutation>;
export type AddSubmissionsMutationResult = Apollo.MutationResult<AddSubmissionsMutation>;
export type AddSubmissionsMutationOptions = Apollo.BaseMutationOptions<AddSubmissionsMutation, AddSubmissionsMutationVariables>;
export const CreateFormBuilderFormDocument = gql`
    mutation createFormBuilderForm($input: FormBuilderFormInput!) {
  createFormBuilderForm(input: $input) {
    id
  }
}
    `;
export type CreateFormBuilderFormMutationFn = Apollo.MutationFunction<CreateFormBuilderFormMutation, CreateFormBuilderFormMutationVariables>;

/**
 * __useCreateFormBuilderFormMutation__
 *
 * To run a mutation, you first call `useCreateFormBuilderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormBuilderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormBuilderFormMutation, { data, loading, error }] = useCreateFormBuilderFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormBuilderFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormBuilderFormMutation, CreateFormBuilderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormBuilderFormMutation, CreateFormBuilderFormMutationVariables>(CreateFormBuilderFormDocument, options);
      }
export type CreateFormBuilderFormMutationHookResult = ReturnType<typeof useCreateFormBuilderFormMutation>;
export type CreateFormBuilderFormMutationResult = Apollo.MutationResult<CreateFormBuilderFormMutation>;
export type CreateFormBuilderFormMutationOptions = Apollo.BaseMutationOptions<CreateFormBuilderFormMutation, CreateFormBuilderFormMutationVariables>;
export const UpdateFormBuilderFormDocument = gql`
    mutation updateFormBuilderForm($id: Int!, $input: FormBuilderFormInput!) {
  updateFormBuilderForm(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateFormBuilderFormMutationFn = Apollo.MutationFunction<UpdateFormBuilderFormMutation, UpdateFormBuilderFormMutationVariables>;

/**
 * __useUpdateFormBuilderFormMutation__
 *
 * To run a mutation, you first call `useUpdateFormBuilderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormBuilderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormBuilderFormMutation, { data, loading, error }] = useUpdateFormBuilderFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormBuilderFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormBuilderFormMutation, UpdateFormBuilderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormBuilderFormMutation, UpdateFormBuilderFormMutationVariables>(UpdateFormBuilderFormDocument, options);
      }
export type UpdateFormBuilderFormMutationHookResult = ReturnType<typeof useUpdateFormBuilderFormMutation>;
export type UpdateFormBuilderFormMutationResult = Apollo.MutationResult<UpdateFormBuilderFormMutation>;
export type UpdateFormBuilderFormMutationOptions = Apollo.BaseMutationOptions<UpdateFormBuilderFormMutation, UpdateFormBuilderFormMutationVariables>;
export const DeleteFormBuilderFormDocument = gql`
    mutation deleteFormBuilderForm($id: Int!) {
  deleteFormBuilderForm(id: $id)
}
    `;
export type DeleteFormBuilderFormMutationFn = Apollo.MutationFunction<DeleteFormBuilderFormMutation, DeleteFormBuilderFormMutationVariables>;

/**
 * __useDeleteFormBuilderFormMutation__
 *
 * To run a mutation, you first call `useDeleteFormBuilderFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormBuilderFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormBuilderFormMutation, { data, loading, error }] = useDeleteFormBuilderFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormBuilderFormMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormBuilderFormMutation, DeleteFormBuilderFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormBuilderFormMutation, DeleteFormBuilderFormMutationVariables>(DeleteFormBuilderFormDocument, options);
      }
export type DeleteFormBuilderFormMutationHookResult = ReturnType<typeof useDeleteFormBuilderFormMutation>;
export type DeleteFormBuilderFormMutationResult = Apollo.MutationResult<DeleteFormBuilderFormMutation>;
export type DeleteFormBuilderFormMutationOptions = Apollo.BaseMutationOptions<DeleteFormBuilderFormMutation, DeleteFormBuilderFormMutationVariables>;
export const CreateFormBuilderSelectDocument = gql`
    mutation createFormBuilderSelect($input: FormBuilderSelectInput!) {
  createFormBuilderSelect(input: $input) {
    id
  }
}
    `;
export type CreateFormBuilderSelectMutationFn = Apollo.MutationFunction<CreateFormBuilderSelectMutation, CreateFormBuilderSelectMutationVariables>;

/**
 * __useCreateFormBuilderSelectMutation__
 *
 * To run a mutation, you first call `useCreateFormBuilderSelectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFormBuilderSelectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFormBuilderSelectMutation, { data, loading, error }] = useCreateFormBuilderSelectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFormBuilderSelectMutation(baseOptions?: Apollo.MutationHookOptions<CreateFormBuilderSelectMutation, CreateFormBuilderSelectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFormBuilderSelectMutation, CreateFormBuilderSelectMutationVariables>(CreateFormBuilderSelectDocument, options);
      }
export type CreateFormBuilderSelectMutationHookResult = ReturnType<typeof useCreateFormBuilderSelectMutation>;
export type CreateFormBuilderSelectMutationResult = Apollo.MutationResult<CreateFormBuilderSelectMutation>;
export type CreateFormBuilderSelectMutationOptions = Apollo.BaseMutationOptions<CreateFormBuilderSelectMutation, CreateFormBuilderSelectMutationVariables>;
export const UpdateFormBuilderSelectDocument = gql`
    mutation updateFormBuilderSelect($id: Int!, $input: FormBuilderSelectInput!) {
  updateFormBuilderSelect(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateFormBuilderSelectMutationFn = Apollo.MutationFunction<UpdateFormBuilderSelectMutation, UpdateFormBuilderSelectMutationVariables>;

/**
 * __useUpdateFormBuilderSelectMutation__
 *
 * To run a mutation, you first call `useUpdateFormBuilderSelectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormBuilderSelectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormBuilderSelectMutation, { data, loading, error }] = useUpdateFormBuilderSelectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFormBuilderSelectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormBuilderSelectMutation, UpdateFormBuilderSelectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormBuilderSelectMutation, UpdateFormBuilderSelectMutationVariables>(UpdateFormBuilderSelectDocument, options);
      }
export type UpdateFormBuilderSelectMutationHookResult = ReturnType<typeof useUpdateFormBuilderSelectMutation>;
export type UpdateFormBuilderSelectMutationResult = Apollo.MutationResult<UpdateFormBuilderSelectMutation>;
export type UpdateFormBuilderSelectMutationOptions = Apollo.BaseMutationOptions<UpdateFormBuilderSelectMutation, UpdateFormBuilderSelectMutationVariables>;
export const DeleteFormBuilderSelectDocument = gql`
    mutation deleteFormBuilderSelect($id: Int!) {
  deleteFormBuilderSelect(id: $id)
}
    `;
export type DeleteFormBuilderSelectMutationFn = Apollo.MutationFunction<DeleteFormBuilderSelectMutation, DeleteFormBuilderSelectMutationVariables>;

/**
 * __useDeleteFormBuilderSelectMutation__
 *
 * To run a mutation, you first call `useDeleteFormBuilderSelectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormBuilderSelectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormBuilderSelectMutation, { data, loading, error }] = useDeleteFormBuilderSelectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFormBuilderSelectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFormBuilderSelectMutation, DeleteFormBuilderSelectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFormBuilderSelectMutation, DeleteFormBuilderSelectMutationVariables>(DeleteFormBuilderSelectDocument, options);
      }
export type DeleteFormBuilderSelectMutationHookResult = ReturnType<typeof useDeleteFormBuilderSelectMutation>;
export type DeleteFormBuilderSelectMutationResult = Apollo.MutationResult<DeleteFormBuilderSelectMutation>;
export type DeleteFormBuilderSelectMutationOptions = Apollo.BaseMutationOptions<DeleteFormBuilderSelectMutation, DeleteFormBuilderSelectMutationVariables>;
export const GetFormsDocument = gql`
    query getForms($input: GetFormsInput) {
  getForms(input: $input) {
    count
    rows {
      ...FormListItem
    }
  }
}
    ${FormListItemFragmentDoc}`;

/**
 * __useGetFormsQuery__
 *
 * To run a query within a React component, call `useGetFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
      }
export function useGetFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormsQuery, GetFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormsQuery, GetFormsQueryVariables>(GetFormsDocument, options);
        }
export type GetFormsQueryHookResult = ReturnType<typeof useGetFormsQuery>;
export type GetFormsLazyQueryHookResult = ReturnType<typeof useGetFormsLazyQuery>;
export type GetFormsQueryResult = Apollo.QueryResult<GetFormsQuery, GetFormsQueryVariables>;
export const GetFormDocument = gql`
    query getForm($id: Int!) {
  getForms(input: {filter: {fields: {id: {val: $id, op: EQUAL}}}}) {
    rows {
      ...Form
    }
  }
}
    ${FormFragmentDoc}`;

/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormQuery(baseOptions: Apollo.QueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
      }
export function useGetFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
        }
export type GetFormQueryHookResult = ReturnType<typeof useGetFormQuery>;
export type GetFormLazyQueryHookResult = ReturnType<typeof useGetFormLazyQuery>;
export type GetFormQueryResult = Apollo.QueryResult<GetFormQuery, GetFormQueryVariables>;
export const GetFormByFilterDocument = gql`
    query getFormByFilter($input: GetFormsInput) {
  getForms(input: $input) {
    rows {
      ...Form
    }
  }
}
    ${FormFragmentDoc}`;

/**
 * __useGetFormByFilterQuery__
 *
 * To run a query within a React component, call `useGetFormByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormByFilterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFormByFilterQuery(baseOptions?: Apollo.QueryHookOptions<GetFormByFilterQuery, GetFormByFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormByFilterQuery, GetFormByFilterQueryVariables>(GetFormByFilterDocument, options);
      }
export function useGetFormByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormByFilterQuery, GetFormByFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormByFilterQuery, GetFormByFilterQueryVariables>(GetFormByFilterDocument, options);
        }
export type GetFormByFilterQueryHookResult = ReturnType<typeof useGetFormByFilterQuery>;
export type GetFormByFilterLazyQueryHookResult = ReturnType<typeof useGetFormByFilterLazyQuery>;
export type GetFormByFilterQueryResult = Apollo.QueryResult<GetFormByFilterQuery, GetFormByFilterQueryVariables>;
export const GetSelectOptionsDocument = gql`
    query getSelectOptions($input: GetSelectOptionsInput) {
  getSelectOptions(input: $input) {
    count
    rows {
      ...SelectOption
    }
  }
}
    ${SelectOptionFragmentDoc}`;

/**
 * __useGetSelectOptionsQuery__
 *
 * To run a query within a React component, call `useGetSelectOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSelectOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSelectOptionsQuery, GetSelectOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectOptionsQuery, GetSelectOptionsQueryVariables>(GetSelectOptionsDocument, options);
      }
export function useGetSelectOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectOptionsQuery, GetSelectOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectOptionsQuery, GetSelectOptionsQueryVariables>(GetSelectOptionsDocument, options);
        }
export type GetSelectOptionsQueryHookResult = ReturnType<typeof useGetSelectOptionsQuery>;
export type GetSelectOptionsLazyQueryHookResult = ReturnType<typeof useGetSelectOptionsLazyQuery>;
export type GetSelectOptionsQueryResult = Apollo.QueryResult<GetSelectOptionsQuery, GetSelectOptionsQueryVariables>;
export const ListFormBuilderFormsDocument = gql`
    query listFormBuilderForms($input: FormBuilderListInput) {
  listFormBuilderForms(input: $input) {
    count
    rows {
      id
      code
      name
      updatedAt
      submissionCount
    }
  }
}
    `;

/**
 * __useListFormBuilderFormsQuery__
 *
 * To run a query within a React component, call `useListFormBuilderFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormBuilderFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormBuilderFormsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListFormBuilderFormsQuery(baseOptions?: Apollo.QueryHookOptions<ListFormBuilderFormsQuery, ListFormBuilderFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormBuilderFormsQuery, ListFormBuilderFormsQueryVariables>(ListFormBuilderFormsDocument, options);
      }
export function useListFormBuilderFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormBuilderFormsQuery, ListFormBuilderFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormBuilderFormsQuery, ListFormBuilderFormsQueryVariables>(ListFormBuilderFormsDocument, options);
        }
export type ListFormBuilderFormsQueryHookResult = ReturnType<typeof useListFormBuilderFormsQuery>;
export type ListFormBuilderFormsLazyQueryHookResult = ReturnType<typeof useListFormBuilderFormsLazyQuery>;
export type ListFormBuilderFormsQueryResult = Apollo.QueryResult<ListFormBuilderFormsQuery, ListFormBuilderFormsQueryVariables>;
export const GetFormBuilderFormDocument = gql`
    query getFormBuilderForm($id: Int!) {
  getFormBuilderForm(id: $id) {
    id
    code
    name
    description
    closingMessage
    logoUrl
    updatedAt
    submissionCount
    sections {
      id
      code
      name
      description
      sortOrder
      items {
        id
        code
        name
        description
        sortOrder
        relatedFormCode
        relatedSectionCode
        relatedItemCode
        relatedItemFieldCode
        itemFields {
          id
          code
          name
          description
          sortOrder
          selectId
          placeholder
          subtitle
          isRequired
          typeCode
        }
      }
    }
  }
}
    `;

/**
 * __useGetFormBuilderFormQuery__
 *
 * To run a query within a React component, call `useGetFormBuilderFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormBuilderFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormBuilderFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormBuilderFormQuery(baseOptions: Apollo.QueryHookOptions<GetFormBuilderFormQuery, GetFormBuilderFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormBuilderFormQuery, GetFormBuilderFormQueryVariables>(GetFormBuilderFormDocument, options);
      }
export function useGetFormBuilderFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormBuilderFormQuery, GetFormBuilderFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormBuilderFormQuery, GetFormBuilderFormQueryVariables>(GetFormBuilderFormDocument, options);
        }
export type GetFormBuilderFormQueryHookResult = ReturnType<typeof useGetFormBuilderFormQuery>;
export type GetFormBuilderFormLazyQueryHookResult = ReturnType<typeof useGetFormBuilderFormLazyQuery>;
export type GetFormBuilderFormQueryResult = Apollo.QueryResult<GetFormBuilderFormQuery, GetFormBuilderFormQueryVariables>;
export const ListFormBuilderSelectsDocument = gql`
    query listFormBuilderSelects($input: FormBuilderListInput) {
  listFormBuilderSelects(input: $input) {
    count
    rows {
      id
      name
      updatedAt
    }
  }
}
    `;

/**
 * __useListFormBuilderSelectsQuery__
 *
 * To run a query within a React component, call `useListFormBuilderSelectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormBuilderSelectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormBuilderSelectsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListFormBuilderSelectsQuery(baseOptions?: Apollo.QueryHookOptions<ListFormBuilderSelectsQuery, ListFormBuilderSelectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormBuilderSelectsQuery, ListFormBuilderSelectsQueryVariables>(ListFormBuilderSelectsDocument, options);
      }
export function useListFormBuilderSelectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormBuilderSelectsQuery, ListFormBuilderSelectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormBuilderSelectsQuery, ListFormBuilderSelectsQueryVariables>(ListFormBuilderSelectsDocument, options);
        }
export type ListFormBuilderSelectsQueryHookResult = ReturnType<typeof useListFormBuilderSelectsQuery>;
export type ListFormBuilderSelectsLazyQueryHookResult = ReturnType<typeof useListFormBuilderSelectsLazyQuery>;
export type ListFormBuilderSelectsQueryResult = Apollo.QueryResult<ListFormBuilderSelectsQuery, ListFormBuilderSelectsQueryVariables>;
export const GetFormBuilderSelectDocument = gql`
    query getFormBuilderSelect($id: Int!) {
  getFormBuilderSelect(id: $id) {
    id
    name
    updatedAt
    options {
      id
      name
      description
      sortOrder
    }
  }
}
    `;

/**
 * __useGetFormBuilderSelectQuery__
 *
 * To run a query within a React component, call `useGetFormBuilderSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormBuilderSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormBuilderSelectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormBuilderSelectQuery(baseOptions: Apollo.QueryHookOptions<GetFormBuilderSelectQuery, GetFormBuilderSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormBuilderSelectQuery, GetFormBuilderSelectQueryVariables>(GetFormBuilderSelectDocument, options);
      }
export function useGetFormBuilderSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormBuilderSelectQuery, GetFormBuilderSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormBuilderSelectQuery, GetFormBuilderSelectQueryVariables>(GetFormBuilderSelectDocument, options);
        }
export type GetFormBuilderSelectQueryHookResult = ReturnType<typeof useGetFormBuilderSelectQuery>;
export type GetFormBuilderSelectLazyQueryHookResult = ReturnType<typeof useGetFormBuilderSelectLazyQuery>;
export type GetFormBuilderSelectQueryResult = Apollo.QueryResult<GetFormBuilderSelectQuery, GetFormBuilderSelectQueryVariables>;
export const ListFormBuilderItemFieldTypesDocument = gql`
    query listFormBuilderItemFieldTypes {
  listFormBuilderItemFieldTypes {
    id
    code
    name
    description
  }
}
    `;

/**
 * __useListFormBuilderItemFieldTypesQuery__
 *
 * To run a query within a React component, call `useListFormBuilderItemFieldTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFormBuilderItemFieldTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFormBuilderItemFieldTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFormBuilderItemFieldTypesQuery(baseOptions?: Apollo.QueryHookOptions<ListFormBuilderItemFieldTypesQuery, ListFormBuilderItemFieldTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFormBuilderItemFieldTypesQuery, ListFormBuilderItemFieldTypesQueryVariables>(ListFormBuilderItemFieldTypesDocument, options);
      }
export function useListFormBuilderItemFieldTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFormBuilderItemFieldTypesQuery, ListFormBuilderItemFieldTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFormBuilderItemFieldTypesQuery, ListFormBuilderItemFieldTypesQueryVariables>(ListFormBuilderItemFieldTypesDocument, options);
        }
export type ListFormBuilderItemFieldTypesQueryHookResult = ReturnType<typeof useListFormBuilderItemFieldTypesQuery>;
export type ListFormBuilderItemFieldTypesLazyQueryHookResult = ReturnType<typeof useListFormBuilderItemFieldTypesLazyQuery>;
export type ListFormBuilderItemFieldTypesQueryResult = Apollo.QueryResult<ListFormBuilderItemFieldTypesQuery, ListFormBuilderItemFieldTypesQueryVariables>;
export const GetSubmissionsDocument = gql`
    query getSubmissions($input: GetSubmissionsInput) {
  getSubmissions(input: $input) {
    count
    rows {
      id
      submissionItemFields {
        itemFieldId
        value
      }
    }
  }
}
    `;

/**
 * __useGetSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSubmissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubmissionsQuery, GetSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubmissionsQuery, GetSubmissionsQueryVariables>(GetSubmissionsDocument, options);
      }
export function useGetSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubmissionsQuery, GetSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubmissionsQuery, GetSubmissionsQueryVariables>(GetSubmissionsDocument, options);
        }
export type GetSubmissionsQueryHookResult = ReturnType<typeof useGetSubmissionsQuery>;
export type GetSubmissionsLazyQueryHookResult = ReturnType<typeof useGetSubmissionsLazyQuery>;
export type GetSubmissionsQueryResult = Apollo.QueryResult<GetSubmissionsQuery, GetSubmissionsQueryVariables>;